import { mdiCloseCircle } from "@mdi/js";
import PictureMixin from "../../mixins/PictureMixin.vue";
import "./EventPictureSlider.sass";
import { mdiArrowExpand } from "@mdi/js";

export default {
  name: "EventPictureSlider",
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  mixins: [PictureMixin],
  data: () => ({
    counter: 0,
    maxWidth: 1920,
    maxHeight: 600,
    overlay: false,
    // icons
    mdiCloseCircle: mdiCloseCircle,
    mdiArrowExpand: mdiArrowExpand
  }),
  mounted() {
    this.onResize();
  },
  created() {
    window.addEventListener("keydown", this.onKeydown.bind(this));
    window.addEventListener("click", this.onClick.bind(this));
  },
  destroyed() {
    window.removeEventListener("keydown", this.onKeydown.bind(this));
    window.removeEventListener("click", this.onClick.bind(this));
  },
  methods: {
    resizePicture(url) {
      const width = this.maxWidth || 1920;
      const height = this.maxHeight || 600;
      const biggest = width > height ? width : height;

      return url.replace(/\/events\//, "/t/" + biggest + "/events/");
    },
    onResize() {
      this.maxWidth = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
      );
      this.maxHeight = Math.max(
        document.documentElement.clientHeight,
        window.innerHeight || 0
      );
    },
    onKeydown($event) {
      // handle keys
      if (this.overlay) {
        switch ($event.keyCode) {
          case 39: // right arrow
            this.counter++;
            break;
          case 37: // left arrow
            if (this.counter === 0)
              this.counter = this.event.pictures.length - 1;
            else this.counter--;
            break;
          case 27: // escpae
            this.overlay = false;
            break;
        }
      }
    },
    onClick($event) {
      // only if clicked outside image - on overlay close myself
      if (
        this.overlay &&
        this.$refs.overlay &&
        this.$refs.overlay.$el &&
        this.$refs.overlay.$el.children[0] === $event.target
      ) {
        this.overlay = false;
      }
    }
  }
};
